import { render, staticRenderFns } from "./o-product-details.vue?vue&type=template&id=e1b5eb8e&scoped=true&"
import script from "./o-product-details.vue?vue&type=script&lang=js&"
export * from "./o-product-details.vue?vue&type=script&lang=js&"
import style0 from "./o-product-details.vue?vue&type=style&index=0&id=e1b5eb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b5eb8e",
  null
  
)

export default component.exports